import { UseMutationResult } from '@tanstack/react-query'

import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { usePortalMutation } from 'src/Libs/api'
import { decommissionInstallation } from '../api/installation-details.api'

interface UseDecommissionInstallationParams {
  onSuccess?: (vars: DecommissionInstallationVariables) => void
  onError?: (vars: DecommissionInstallationVariables) => void
}

interface DecommissionInstallationVariables {
  installationId?: number | string
  payload: { reason: string }
}

type UseDecommissionInstallationReturnType = (
  data: UseDecommissionInstallationParams
) => UseMutationResult<null, unknown, DecommissionInstallationVariables>

export const useDecommissionInstallation: UseDecommissionInstallationReturnType = ({ onError, onSuccess }) => {
  const authFetch = useAuthFetchWithResponse()

  const mutationResult = usePortalMutation({
    mutationFn: (vars: DecommissionInstallationVariables) => decommissionInstallation(vars.installationId, vars.payload, authFetch),
    onSuccess: (_, vars) => onSuccess?.(vars),
    onError: (_, vars) => onError?.(vars),
  })

  return mutationResult
}
